import * as React from 'react';
import { StyledTooltipTitleWithIcon } from '@components/WithDescriptionTooltip/StyledTooltipTitleWithIcon';
import { AvTooltip } from '@fabric-ui/components';
import { QuestionFull } from '@fabric-ui/icons';
import { SvgIcon } from '@mui/material';

function DescriptionTooltip({ avTooltipProps, tooltipProps }) {
  return (
    <AvTooltip
      {...avTooltipProps}
      {...tooltipProps}
      muiProps={{
        ...avTooltipProps.muiProps,
        PopperProps: {
          'data-tooltip-id': tooltipProps.id,
          ...avTooltipProps.muiProps?.PopperProps,
          ...tooltipProps.PopperProps,
        },
        placement: 'right',
      }}
      title={<StyledTooltipTitleWithIcon>{tooltipProps.title}</StyledTooltipTitleWithIcon>}>
      <SvgIcon component="span">
        <QuestionFull viewBox="0 0 20 20" />
      </SvgIcon>
    </AvTooltip>
  );
}

export default DescriptionTooltip;
